import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';

import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Router, ActivatedRoute    } from '@angular/router';
import { Client } from 'src/app/entity/exhibitor';
 import { Subscription, Observable } from 'rxjs';

import { FormGroup, FormBuilder } from '@angular/forms';
import { FactureService } from 'src/app/service/facture.service';
import { FilterClient } from 'src/app/entity/Filter';
import { Pays, Prospect } from 'src/app/entity/prospect';
import { Socifact } from 'src/app/entity/Facture';
import { AppSettings } from 'src/app/service/app.setting';
import { MailsService } from 'src/app/service/mails.service';
import { ComposeMailComponent } from '../email/include/compose-mail/compose-mail.component';
import { ContactService } from 'src/app/service/contact.service';
import { Anonyme } from 'src/app/entity/Anonyme';
import { Staff } from 'src/app/entity/Staff';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { StaffService } from 'src/app/service/staff.service';

import { ConfirmationService } from 'primeng/api';
import { ProspectService } from 'src/app/service/prospect.service';
import { environment } from 'src/environments/environment';
import { PackagesponsorService } from 'src/app/service/package.service';
@Component({
    selector: 'app-client-list',
    templateUrl: './client-list.component.html',
    styleUrls: ['./client-list.component.css']
})
export class ClientListComponent implements OnInit, OnDestroy {
    contactForm: FormGroup;
    visibleUsers: boolean;
    visibleStatus: boolean;
    loadingPrint:boolean=false;
    loadingProforma:boolean=false;

     visibleImporter:boolean
    
    userId: number;
    listType: string;
    socifact: string;
    actualTarget: any;
    displayedColumns: string[];
    dataSource = new MatTableDataSource();
    payss: Observable<Pays[]>;
    screenHeight: any;
    screenWidth: any;
    selectedClient: Client;
    clientType: string;
    nbrRecords: number;
    filterClient: FilterClient;
    selectedClientId: number;
    private routeSub: Subscription;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(ComposeMailComponent)
    private composeMailComponent: ComposeMailComponent;
    socifacts: Observable<Socifact[]>;
    pavillon: string;
    languages: { label: string; value: string; }[];
    selectedLangue: string;
    selectedTypePaiement: string;
    showFilter: boolean;
    stranger: string;
    currentUser: Staff;
    visibleArchiver: boolean
    typesPaiement: { label: string; value: string; }[];
    status: string;
    commercial: number;
    staffs: Staff[]
    selectedStaff: Staff;
    filteredStaffs: Staff[];

    typeClients = AppSettings.TYPES_CLIENTS



    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;


    }


    filterCountry(event) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.staffs.length; i++) {
            let country = this.staffs[i];
            if (country.nom.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(country);
            }
        }

        this.filteredStaffs = filtered;
    }
    findAllStaffs() {
        this.staffService.getAllStaffs().subscribe(result => {
            this.staffs = result
            this.staffs.forEach(element => {
               /// //console.log("this.staffs" + JSON.stringify(element));
            });



        })
    }
    constructor(
        private formBuilder: FormBuilder,
        private exhibitorService: ExhibitorService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private staffService: StaffService,
        private prospectService: ProspectService,
        private packageService: PackagesponsorService,
        private activatedRoute: ActivatedRoute,
        private contactService: ContactService,
        private factureService: FactureService,
        private mailsService: MailsService,
        private dialog: MatDialog) {

        this.screenHeight = window.screen.height;
        this.screenWidth = window.screen.width;

        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.routeSub = this.activatedRoute.params.subscribe(params => {






            if (params['idClient'])
                this.exhibitorService.getExhibitor(params['idClient']).subscribe(result => {
                    this.selectedClient = result;
                    this.typeClient();
                    this.selectedClientId = this.selectedClient.idClient;
                })
            if (params['idUser']) {
                this.userId = params['idUser'];
                this.userId = this.userId / 9555;
                localStorage.setItem('idUser', this.userId + '');



                this.listType = params['typeClient'];


               
                // this.filtrer();
         
                let filterClient = new FilterClient();
                filterClient.userId = this.userId;
                filterClient.typeClient = this.listType;
                filterClient.socifact = this.socifact;
                filterClient.langue = this.selectedLangue;
                filterClient.pavillon = this.pavillon;
                filterClient.stranger = this.stranger;
                filterClient.status = this.status;
                if (this.selectedStaff)
                    filterClient.commercial = this.selectedStaff.userId;

                filterClient.paiement = this.selectedTypePaiement;
                if (this.selectedClientId)
                    filterClient.maxResult = 11120;
                else
                    filterClient.maxResult = 20;
                this.filterClients(filterClient);
                //console.log(1);

                //    if (!this.listType || !this.userId || this.listType!=params['typeClient'] || this.userId!=params['idUser']/9555 )




            }
        });
        this.findAllStaffs()
    }

    ngOnInit() {
 

        // this.dataSource.paginator = this.paginator;
        //  this.dataSource.sort = this.sort;

        this.buildContactForm();
        this.socifacts = this.factureService.getAllSociFactOrder();
        this.initLanguage();
        this.typesPaiement = [
            { label: 'Payé 100%', value: 't' },
            { label: 'Partiel', value: 'p' },
            { label: 'Non payé', value: 'n' },
            { label: 'Autre', value: 'a' },
            { label: 'Co-Exposant', value: 'c' },
            { label: 'All', value: '' }
        ];

    }


    displayFn(staff?: Staff): string | undefined {
        return staff ? staff.nom : "";
    }

    buildContactForm(): void {
        this.contactForm = this.formBuilder.group({
            'nom': [''],
            'mobile': [''],
            'tel': [''],
            'mail': [''],
            'position': ['']
        });
    }


    addClient() {
        this.exhibitorService.addClient(this.listType, this.dataSource.filter).subscribe(result => {
            //console.log("result" + JSON.stringify(result));
            this.selectedClient = result;
            this.router.navigateByUrl(`/add-exhibitor/${this.selectedClient.idClient}/0`)
        }

        );
    }

    async confirmer() {
        //console.log("this.selectedClient" + JSON.stringify(this.selectedClient));
      //  let prospect: Prospect = this.prospectService.copyProspect(this.selectedClient.prospectId)
        //let client:Client 

        // this.prospectService.saveProspectErpErp(prospect)
        let result = await this.exhibitorService.confirmExhibitorERP(this.selectedClient)

        result.subscribe(async result1 => {
            let client: Client = result1;
             this.contactService.findContactsByProspect(this.selectedClient.prospectId.prospectId).subscribe(async data => {
                console.log("data",data);
             await   this.exhibitorService.confirmContactsERP(data, client).catch(e=>{
                 // console.log("erroe",e);
                    
                })

            })
            this.factureService.findContract(this.selectedClient.idClient).subscribe(result => {
         
                if ( result) {
                    this.exhibitorService.confirmProformaERP(result,client)
   
                }
          
              })


            let idUserCrypted = +localStorage.getItem("idUser") * 9555
            window.open(`${environment.erpAdresse}/client-list/${client.type}/${idUserCrypted}/${client.idClient}`)
            //console.log("resultresultresultresult ", result1);




        }

        )

    }





    /* applyFilter(filterValue: string) {
   if(filterValue)
        this.exhibitorService.findByRaisonTypeUser(filterValue,this.listType,this.userId).subscribe(result => {
               this.dataSource.data = result;
         })
   else
   this.loadClientsType(this.userId,this.listType)
       } */



    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

    }



    /*  applyFilter(filterValue: string) {
          this.dataSource.filter = filterValue.trim().toLowerCase();
        }*/
    filterClients(filterClient: FilterClient) {

        //console.log("start filter");
 

        this.exhibitorService.filterClientsAnonyme(filterClient).subscribe(data => {
            //console.log("end filter");
            this.dataSource.data = data;
            this.nbrRecords = data.length;

            /*
            if(this.nbrRecords>19 && filterClient.maxResult==20){
                filterClient.maxResult=1000;
                this.exhibitorService.filterClients(filterClient).subscribe(data => {
                    //console.log("end filter");
                    this.dataSource.data = data;
                this.nbrRecords=data.length;
                 
                });
            }*/

        });


    }

    xxxxx() {
        //console.log("filtrerthis.status  2" + this.status);


        let filterClient = this.getFilterClient();

        this.filterClients(filterClient);
    }
    getFilterClient(): FilterClient {
        let filterClient = new FilterClient();
        filterClient.userId = this.userId;
        filterClient.typeClient = this.listType;
        filterClient.socifact = this.socifact;
        filterClient.langue = this.selectedLangue;
        filterClient.pavillon = this.pavillon;
        filterClient.stranger = this.stranger;
        filterClient.status = this.status;
        if (this.selectedStaff)
            filterClient.commercial = this.selectedStaff.userId;
        filterClient.paiement = this.selectedTypePaiement;
        return filterClient;
    }


    editExhibitor(id: number): void {
        this.router.navigateByUrl('/add-exhibitor/' + id)
    }
    /*arrowDownEvent(row: object, clie: number){
        //console.log(index);
        var nextrow = this.dataSource[index];
         this.sel(nextrow);
      }*/
    /* deleteExhibitor(exhibitor: Client): void {
         // Create configuration for the dialog
         const dialogConfig = new MatDialogConfig();
         dialogConfig.disableClose = true;
         dialogConfig.autoFocus = true;
         dialogConfig.height = '200px';
         dialogConfig.width = '400px';
         dialogConfig.data = {
             title: `Delete  ${exhibitor.prospectId.raisonSocial} `,
             message: 'Are you sure?'
         };
 
         const dialogRef = this.dialog.open(ConfirmedDialogComponent, dialogConfig);
 
         dialogRef.afterClosed().subscribe(result => {
             if (result) {
                 this.dataSource.data = this.dataSource.data.filter(e => e != exhibitor);
                 this.exhibitorService.deleteExhibitor(exhibitor).subscribe();
             }
         });
     }*/

    getFullName(exhibitor: Client): string {
        return exhibitor.prospectId.raisonSocial;
    }

    selectRow(anonyme: Anonyme) {


        let userId = this.userId * 9555;
        this.router.navigateByUrl("/client-list/" + this.listType + '/' + userId + '/' + anonyme.l1)
        this.typeClient()
    }



    printFiche() {

        this.exhibitorService.printFiche(this.selectedClient.idClient).subscribe(
            (res: any) => {

                var filename = 'restfile.pdf';

                filename = filename.replace(/[/\\?%*:|"<>]/g, '-');



                var fileURL = URL.createObjectURL(res);
                window.open(fileURL);

            }
        );
    }
    typeClient() {
        if (this.selectedClient) {
            if (this.selectedClient.type === 'E')
                this.clientType = "Exposant";
            else if (this.selectedClient.type === 'ES')
                this.clientType = "Exposant Sponsor";
            else if (this.selectedClient.type === 'C') {

                this.clientType = "Co-Exposant " + this.selectedClient.exposantPstring;


            }
            else if (this.selectedClient.type === 'D')
                this.clientType = "Délégué";
            else if (this.selectedClient.type === 'S')
                this.clientType = "Sponsor";
            else if (this.selectedClient.type === 'AE')
                this.clientType = "Exposant Archivé";
            else if (this.selectedClient.type === 'AS')
                this.clientType = "Sponsor Archivé";
            else if (this.selectedClient.type === 'AC')
                this.clientType = "Co-Exposant Archivé";
            else if (this.selectedClient.type === 'AD')
                this.clientType = "Délégué Archivé";


            //console.log(this.clientType);
        }


    }
    printInvoice() {
console.log(      this.loadingProforma);

        if (this.selectedClient) {
            this.loadingProforma=true;
            let en = false;
            if (this.selectedClient.prospectId.langue == "EN")
                en = true;

            this.exhibitorService.findContratClient(this.selectedClient.idClient).subscribe(result => {
                this.factureService.printFactureProforma(result, en).subscribe(
                    (res: any) => {
                        if(res){
                            var filename = 'restfile.pdf';

                            filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
    
    
    
                            var fileURL = URL.createObjectURL(res);
                            window.open(fileURL);
                            this.loadingProforma=false;
                        }
                        else{
                            alert("Veuillez vérifier votre facture")
                            this.loadingProforma=false; 
                        }

                   
           

                    });
            })
        }


    }
    printParticipants() {

        let filterClient = this.getFilterClient();
this.loadingPrint=true;
        this.exhibitorService.printParticipants(filterClient).subscribe(
            (res: any) => {
                this.loadingPrint=false;
                var filename = 'participantListNAPEC2020.pdf';

                filename = filename.replace(/[/\\?%*:|"<>]/g, '-');



                var fileURL = URL.createObjectURL(res);
                //    window.open(fileURL);
                import("file-saver").then(FileSaver => {
                    FileSaver.saveAs(res, "participantList.pdf");
                })
            }
        );

    }
    gotoLogistiques(idModel: number) {

        this.mailsService.findodel(idModel).subscribe(result => {
            let model = result;


            this.exhibitorService.getEnCryptClient(this.selectedClient.idClient).subscribe(result => {
                let idSalon = AppSettings.ID_SALON;
                let idExpoDecalEncrypt = result.crypt;
                model.corp = model.corp.replace("@idsalon", idSalon + "")
                model.corp = model.corp.replace("@id", idExpoDecalEncrypt)
                /* if(this.selectedClient.type === 'D'){
                   model.corp= model.corp.replace("com/exposant/portal","com/delegate/portal" )
                   //console.log("typothis.selectedClient.type"+this.selectedClient.type+'2');
                 }
                else
                 //console.log("typo"+this.selectedClient.type);
                 */
                this.contactService.findContactsByProspect(this.selectedClient.prospectId.prospectId).subscribe(result => {
                    let toall: string;
                    result.forEach(element => {
                        if (element && toall)
                            toall = element.mail + ';' + toall;
                        else if (element)
                            toall = element.mail
                        //console.log('element.mail' + element.mail);


                    });

                    this.composeMailComponent.prepareEmailNormal(toall, "NAPEC", this.selectedClient.prospectId, this.selectedClient)

                })



                //  window.open('http://ecatalog.napec-dz.com/exposant/portal.aspx?SALON='+idSalon+'&expid='+idExpoDecalEncrypt,'_blank');
            })
        })
    }


    displayPaysFn(pays?: Pays): string | undefined {
        return pays ? pays.designationFr : "";
    }
    initLanguage() {
        this.languages = [
            { label: 'Français', value: 'fr' },
            { label: 'English', value: 'en' },
        ];;
    }
    ngOnDestroy(): void {
        this.routeSub.unsubscribe();
    }



    basculer($event) {
        let anonyme: Anonyme = new Anonyme();
        let staff: Staff
        this.visibleUsers = false;
        if ($event) {
            staff = $event;
            this.selectedClient.concretiserPar = staff.nom;
            //console.log("basculerthis.exhibitorService.basculer");

            this.exhibitorService.basculer(staff, this.selectedClient.idClient).subscribe(
                result => {

                    this.selectedClient = result;

                }
            )
        }


    }

    confirm() {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to perform this action?',
            accept: () => {
                this.archiver();
            }
        });
    }
    archiver() {
        this.exhibitorService.archiver(this.selectedClient).subscribe(result => {
            let filterClient = this.getFilterClient();
            this.filterClients(filterClient)
        });

    }


    //changeStatus('En Attente  Ctr','#82A971')
    changerType(type: string) {


        this.exhibitorService.updateChamp(this.selectedClient, "type", type).subscribe(
            result => {
                let idUserCrypted = +localStorage.getItem("idUser") * 9555
                this.router.navigateByUrl(`/client-list/${type}/${idUserCrypted}/${this.selectedClient.idClient}`)

            }
        )
    }

    changeStatus(status: string, color: string) {
        this.exhibitorService.updateStatus(this.selectedClient, status, color).subscribe(
            result => {
                let filterClient = this.getFilterClient();
                this.filterClients(filterClient)
            }
        )

    }
    onHideImporter(){
        this.visibleImporter=false;
       this. xxxxx() 
    }
 
}

